import { render, staticRenderFns } from "./signal.vue?vue&type=template&id=285829a2&"
import script from "./signal.vue?vue&type=script&lang=js&"
export * from "./signal.vue?vue&type=script&lang=js&"
import style0 from "./signal.vue?vue&type=style&index=0&id=285829a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports